const SVG_NS = "http://www.w3.org/2000/svg";
const NONE = "none";
const POINT_DIGITS = 3;

export { SVG_NS, NONE, POINT_DIGITS };